import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Clear cache on app initialization to prevent stale auth state
if (typeof window !== 'undefined') {
  // Only clear cache if we're NOT coming from a Google redirect
  // Check URL for redirect indicators
  const urlParams = new URLSearchParams(window.location.search);
  const isRedirect = urlParams.has('__firebase_request_key') || 
                     window.location.hash.includes('access_token') ||
                     window.location.hash.includes('id_token');
  
  if (!isRedirect) {
    // Clear localStorage items that might cache stale auth state
    // But only if we're not in the middle of a redirect
    const keysToClear = [
      'firebase:authUser',
      'firebase:redirectUser',
      'firebase:host:auth',
    ];
    
    keysToClear.forEach(key => {
      try {
        if (localStorage.getItem(key)) {
          console.log(`[CACHE] 🗑️ Clearing cached key: ${key}`);
          localStorage.removeItem(key);
        }
      } catch (e) {
        // Ignore errors (might be in private browsing mode)
      }
    });

    // Clear sessionStorage as well (but preserve redirect state)
    try {
      // Only clear non-Firebase sessionStorage items
      const sessionKeys = Object.keys(sessionStorage);
      sessionKeys.forEach(key => {
        if (!key.includes('firebase') && !key.includes('redirect')) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {
      // Ignore errors
    }
  }

  // Expose cache clearing function for development
  if (process.env.NODE_ENV === 'development') {
    window.clearAuthCache = () => {
      try {
        localStorage.clear();
        sessionStorage.clear();
        const { getAuth, signOut } = require('firebase/auth');
        const auth = getAuth();
        if (auth.currentUser) {
          signOut(auth).then(() => window.location.reload());
        } else {
          window.location.reload();
        }
      } catch (e) {
        console.error('[CACHE] Error clearing cache:', e);
      }
    };
  }

  // Suppress Firebase Remote Config IndexedDB errors (non-critical)
  // These occur when IndexedDB is unavailable (private browsing, etc.)
  const originalError = console.error;
  console.error = (...args) => {
    // Filter out Remote Config IndexedDB errors
    const message = args[0]?.toString() || '';
    if (message.includes('Remote Config') && message.includes('indexedDB')) {
      // Silently ignore - Remote Config is optional
      return;
    }
    originalError.apply(console, args);
  };

  // Also catch unhandled promise rejections from Remote Config
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    if (error?.code === 'remoteconfig/storage-open' || 
        (error?.message && error.message.includes('Remote Config') && error.message.includes('indexedDB'))) {
      event.preventDefault(); // Suppress the error
      return;
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
